module.exports = __webpack_public_path__ + "img/Consultation.32a97e9d.png";